import { TextInputField } from './TextInputField';
import type { FormFieldComponent } from './types';
import { fieldRule, readFormField } from './useFormField';

const ROLE = 'genericInputField';
const FALLBACK_NAME = 'numberFormField';

const GenericFormNumberInputField: FormFieldComponent = () => (
  <TextInputField role={ROLE} fallbackName={FALLBACK_NAME} type="number" multiline={false} />
);

GenericFormNumberInputField.formSchema = content => fieldRule(readFormField(content, 'genericFields', ROLE), FALLBACK_NAME);

export default GenericFormNumberInputField;
